import React, { useState } from 'react';
import { useCart } from './CartContext';
import { useAuth } from './AuthContext';
import { useNavigate } from 'react-router-dom';
import './Cart.css';
import { resolveImageUrl } from '../utils/resolveImageUrl';
import getApiBase from "../utils/apiBase";
import Seo from '../components/Seo';
import Modal from '../components/Modal';
import { useI18n } from '../i18n/I18nContext';
import { flushAnalytics, trackAnalyticsEvent } from '../utils/analytics';

const API_BASE = getApiBase();
//import { useNavigate } from 'react-router-dom';

const Cart = () => {
  const { cart, dispatch } = useCart();
  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [selectedCountry, setSelectedCountry] = useState(""); // 初始国家代码
  const [checkoutError, setCheckoutError] = useState("");
  const [loginModalOpen, setLoginModalOpen] = useState(false);
  const { t, formatNumber, formatRegion } = useI18n();
  const displayColor = (value) => !value || value === 'Default' ? t('common.default') : value;

  // 国家列表
  const countryOptions = [
    { code: 'US', name: 'United States' },
    { code: 'CA', name: 'Canada' },
    { code: 'JP', name: 'Japan' },
    { code: 'KR', name: 'South Korea' },
    { code: 'HK', name: 'Hong Kong' },
    { code: 'SG', name: 'Singapore' },
    { code: 'AU', name: 'Australia' },
    { code: 'AE', name: 'United Arab Emirates' },
    { code: 'AT', name: 'Austria' },
    { code: 'BE', name: 'Belgium' },
    { code: 'BG', name: 'Bulgaria' },
    { code: 'BR', name: 'Brazil' },
    { code: 'CH', name: 'Switzerland' },
    { code: 'CL', name: 'Chile' },
    { code: 'CY', name: 'Cyprus' },
    { code: 'CZ', name: 'Czech Republic' },
    { code: 'DE', name: 'Germany' },
    { code: 'DK', name: 'Denmark' },
    { code: 'EE', name: 'Estonia' },
    { code: 'ES', name: 'Spain' },
    { code: 'FI', name: 'Finland' },
    { code: 'FR', name: 'France' },
    { code: 'GB', name: 'United Kingdom' },
    { code: 'GR', name: 'Greece' },
    { code: 'HU', name: 'Hungary' },
    { code: 'IE', name: 'Ireland' },
    { code: 'IL', name: 'Israel' },
    { code: 'IN', name: 'India' },
    { code: 'IT', name: 'Italy' },
    { code: 'LT', name: 'Lithuania' },
    { code: 'LU', name: 'Luxembourg' },
    { code: 'LV', name: 'Latvia' },
    { code: 'MT', name: 'Malta' },
    { code: 'MX', name: 'Mexico' },
    { code: 'NL', name: 'Netherlands' },
    { code: 'NO', name: 'Norway' },
    { code: 'NZ', name: 'New Zealand' },
    { code: 'PL', name: 'Poland' },
    { code: 'PT', name: 'Portugal' },
    { code: 'RO', name: 'Romania' },
    { code: 'SE', name: 'Sweden' },
    { code: 'SI', name: 'Slovenia' },
    { code: 'SK', name: 'Slovakia' },
    { code: 'TH', name: 'Thailand' },
    { code: 'ZA', name: 'South Africa' },
  ];
  
  //const navigate = useNavigate();

  // const handleCheckout = () => {
  //   // 导航到checkout表单页面
  //   navigate('/checkout');
  // };
  const openLoginModal = () => {
    setLoginModalOpen(true);
  };

  const goToAuthPage = (path) => {
    setLoginModalOpen(false);
    navigate(`${path}?next=${encodeURIComponent('/cart')}`);
  };

  const handleCheckout = async () => {
    setCheckoutError("");
    if (!cart.length) {
      console.error('Cart is empty');
      return;
    }
    if (authLoading) {
      return;
    }
    trackAnalyticsEvent('checkout_start', {
      target: 'cart.checkout',
      quantity: cart.reduce((total, item) => total + item.quantity, 0),
    });
    if (!user) {
      openLoginModal();
      return;
    }
    console.log('cart:', cart);

    //http://127.0.0.1:5000/api/create-checkout-session //本地测试https://ych-yoyo.com/api/create-checkout-session

    const response = await fetch(`${API_BASE}/api/create-checkout-session`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: cart.map(item => ({
          id: item.id,
          itemKey: item.itemKey,
          type: item.type,
          name: item.name,
          imageUrl: item.imageUrl,
          price: item.price,
          quantity: item.quantity,
          color: item.selectedColor, // Include the selected color
          selectedColor: item.selectedColor,
          customColorId: item.customColorId,
          customColorName: item.customColorName,
          customColorGroup: item.customColorGroup,
          customColorImageUrl: item.customColorImageUrl,
          artworkUrl: item.artworkUrl,
          previewImageUrl: item.previewImageUrl,
          previewDraft: item.previewDraft,
        })),
        country_code: selectedCountry,
      }),
      credentials: 'include',
    });
  
    const session = await response.json();
    if (!response.ok) {
      if (response.status === 401) {
        openLoginModal();
        return;
      }
      setCheckoutError(t('cart.checkoutError'));
      return;
    }
  
    // 重定向到 Stripe 的结账页面
    if (session.url) {
      trackAnalyticsEvent('checkout_redirect', { target: 'cart.checkout' });
      flushAnalytics({ keepalive: true });
      dispatch({ type: 'CLEAR_CART' });
      window.location.href = session.url;
    }
  };

  const increaseQuantity = (item) => {
    dispatch({
      type: 'INCREASE_QUANTITY',
      payload: { id: item.id, selectedColor: item.selectedColor, itemKey: item.itemKey },
    });
  };
  
  const decreaseQuantity = (item) => {
    dispatch({
      type: 'DECREASE_QUANTITY',
      payload: { id: item.id, selectedColor: item.selectedColor, itemKey: item.itemKey },
    });
  };
  
  const removeFromCart = (item) => {
    dispatch({
      type: 'REMOVE_ITEM',
      payload: { id: item.id, selectedColor: item.selectedColor, itemKey: item.itemKey },
    });
  };
  

  const calculateTotal = () => {
    return cart.reduce((total, item) => total + item.price * item.quantity, 0);
  };

  

  return (
    <div className="cart">
      <Seo
        title={t('header.cart')}
        description={t('cart.seoDescription')}
        path="/cart"
        noindex
      />
      <h1>{t('cart.title')}</h1>
      {cart.length === 0 ? (
        <p>{t('cart.empty')}</p>
      ) : (
        <ul>
          {cart.map(item => (
            <div key={item.itemKey || `${item.id}-${item.selectedColor}`} className="cart-item">
                <img src={resolveImageUrl(item.imageUrl)} alt={item.name} className="cart-item-image" />
                <p>
                  {item.name} - {displayColor(item.selectedColor)}
                  {item.type === 'custom_yoyo' ? <span className="cart-item-note"> {t('cart.artworkAfterPayment')}</span> : null}
                </p>
                <div className="quantity-control">
                    <button data-analytics-target="cart.quantity.decrease" aria-label={t('cart.decreaseQuantity', { item: item.name })} onClick={() => decreaseQuantity(item)}>-</button>
                    <p>{item.quantity}</p>
                    <button data-analytics-target="cart.quantity.increase" aria-label={t('cart.increaseQuantity', { item: item.name })} onClick={() => increaseQuantity(item)}>+</button>
                </div> 
                <p>{t('common.price', { price: formatNumber(Number(item.price), { style: 'currency', currency: 'USD' }) })}</p>
                <button data-analytics-target="cart.remove" onClick={() => removeFromCart(item)}>{t('cart.remove')}</button>
            </div>
          ))}
          
        </ul>
      )}
      
      {cart.length === 0 ? (
        <></>
      ) : (<div className="checkout-area">
            <p className="total-cost">{t('cart.total', { total: formatNumber(calculateTotal(), { style: 'currency', currency: 'USD' }) })}</p>
             {/* 国家选择器 */}
            <label htmlFor="country-select">{t('cart.countryLabel')}</label>
            <select
              id="country-select"
              value={selectedCountry}
              onChange={(e) => setSelectedCountry(e.target.value)}
              className="country-select"
            >
              <option value="" disabled>{t('cart.countrySelect')}</option> {/* 默认空选项 */}
              {countryOptions.map((country) => (
                <option key={country.code} value={country.code}>
                  {formatRegion(country.code)}
                </option>
              ))}
            </select>
            
            {checkoutError && <p className="cart-error">{checkoutError}</p>}
            <button data-analytics-target="cart.checkout" className="checkout-button" onClick={handleCheckout} disabled={!selectedCountry || authLoading}>{t('cart.checkout')}</button>
            <p><strong>{t('cart.unlistedCountry')}</strong></p>
      </div>)}

      {loginModalOpen ? (
        <Modal
          title={t('cart.loginRequired')}
          message={t('cart.loginPrompt')}
          onClose={() => setLoginModalOpen(false)}
          primaryAction={{
            label: t('header.login'),
            onClick: () => goToAuthPage("/login"),
          }}
          secondaryAction={{
            label: t('auth.register.title'),
            onClick: () => goToAuthPage("/register"),
          }}
        />
      ) : null}
    </div>
  );
};

export default Cart;
